import fuse from '../../../_libs/redux-fusion';
import {getOrganizationReduxItem} from '../../../app/model/reducers/state';
import {buildOrganizationLink$} from '../../../app/navigation/utils';
import {OrgCalendarComponent} from './OrgCalendarComponent';


export const StreamedComponent = (state$, dispatch) => (props$) => {
  const breadcrumbPath$ = buildOrganizationLink$(state$)
    .map(link => [link]);

  const orgId$ = state$
    .map(state => getOrganizationReduxItem(state).id)
    .distinctUntilChanged()
    .takeUntil(props$.last());

  return props$
    .combineLatest(
      orgId$,
      breadcrumbPath$,
      (props, orgId, breadcrumbPath) => ({
        ...props,
        orgId,
        breadcrumbPath,
      }));
};

export const OrgCalendarContainer = fuse(StreamedComponent)(OrgCalendarComponent);



// WEBPACK FOOTER //
// ./src/js/calendar/components/OrgCalendar/OrgCalendarContainer.js